import { useCallback, useState } from 'react';
import { useI18n } from '@namespace/i18n';
import { useNotifications } from '@namespace/notifications';
import { getTaxes, getTaxesNew } from '../../api/taxes';
import {
  STORE_PROPS,
  useGetPaymentService,
  usePaymentsStore
} from '../../store';
import { ApiError } from '../../types/apiError';
import { formatErrorMessage } from '../../utils';

const { ACTIVE_SERVICE_ID, ACTIVE_PAYMENT_TYPE } = STORE_PROPS;

export const useTaxApi = (isNewTaxAPI = false) => {
  const [isFetching, setIsFetching] = useState(false);
  const { activeServiceId, activePaymentType } = usePaymentsStore([
    ACTIVE_SERVICE_ID,
    ACTIVE_PAYMENT_TYPE
  ]); // TODO: remove types once types will be added to usePaymentsStore
  const { currency } = useGetPaymentService();
  const { errorNotification } = useNotifications();
  const { t } = useI18n();

  const apiRequest = isNewTaxAPI ? getTaxesNew : getTaxes;

  const loadTaxes = useCallback(
    async (amount: number) => {
      try {
        setIsFetching(true);
        const responseData = await apiRequest({
          amount,
          currency: currency as string,
          serviceId: activeServiceId as number,
          paymentType: activePaymentType as string
        });

        return responseData;
      } catch (response) {
        const { errorCode } = response as ApiError;
        errorNotification(t(formatErrorMessage(errorCode)));
      } finally {
        setIsFetching(false);
      }
      return null;
    },
    [
      activePaymentType,
      activeServiceId,
      apiRequest,
      currency,
      errorNotification,
      t
    ]
  );

  return {
    loadTaxes,
    isFetching
  };
};
